import { UpdateStreetTypeComponent } from './update-street-type/update-street-type.component'
import { CreateStreetTypeComponent } from './create-street-type/create-street-type.component'
import { StreetTypesComponent } from './street-types.component'
import { MainLayoutComponent } from '@components/main-layout/main-layout.component'
import { Routes } from '@angular/router'
import { AuthGuard } from 'src/app/guards/auth.guard'
import { NgxPermissionsGuard } from 'ngx-permissions'

export const streetTypesRoutes: Routes = [
  {
    path: 'admin/street-types',
    component: MainLayoutComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        only: 'SYSTEM_MANAGEMENT_PANEL',
        redirectTo: '/',
      },
    },
    children: [
      {
        path: '',
        component: StreetTypesComponent,
        data: {
          permissions: {
            only: 'SYSTEM_MANAGEMENT_PANEL',
            redirectTo: '/',
          },
        },
      },
      {
        path: 'create',
        component: CreateStreetTypeComponent,
        data: {
          permissions: {
            only: 'SYSTEM_MANAGEMENT_PANEL',
            redirectTo: '/',
          },
        },
      },
      {
        path: ':id/update',
        component: UpdateStreetTypeComponent,
        data: {
          permissions: {
            only: 'SYSTEM_MANAGEMENT_PANEL',
            redirectTo: '/',
          },
        },
      },
    ],
  },
]
